import { ENTITIES } from "./entities";

export interface QueryParams {
  children?: Array<ENTITIES>;
  page_num?: number;
  page_size?: number;
  ds_col?: Array<string>;
  ds_interval?: string;
  ds_nb_pts?: number;
  sorters?: Array<QueryParamSorters>;
  filter?: Array<QueryParamFilter>;
}

export interface QueryParamFilter {
  filter_col?: string;
  filter_op?: FILTER_OPERATION;
  filter_val?: string | number | Array<string> | Array<number>;
}

export interface QueryParamSorters {
  sort_col?: string;
  sort_order?: SORT_ORDER;
}

export interface QueryParamProccesed {
  filter_cols?: string | number;
  filter_ops?: string | number;
  filter_vals?: string | number;
  children?: string | string[];
  page_num?: number;
  page_size?: number;
  sort_cols?: string;
  sort_col?: string;
  sort_order?: string;
  ds_cols?: string | string[];
  ds_interval?: string;
}

export interface QueryParamV2 {
  activity_id?: string | number;
  surface_report_id?: string | number;
  report_id?: string | number;
}

export enum SORT_ORDER {
  DESCENDING = -1,
  ASCENDING = 1,
}

export type FILTER_OPERATION =
  | "="
  | "!="
  | ">="
  | "<="
  | ">"
  | "<"
  | "IN"
  | "NOT IN";

export interface Meta {
  count: number;
  total_count: number;
  global_count: number;
  global_time_max: string;
  global_time_min: string;
  time_max: string;
  time_min: string;
}

// TODO rename to API_PATH
export enum HTTP_PATH {
  ADD = "add",
  ID = "id",
  LOGIN = "login",
  REGISTER = "register",
  UPDATE = "update",
  SAVE = "save",
  UPLOAD = "upload",
}

export type DeleteResponse = {};
